import { useState } from 'react'
import React from "react";

const initialState = {
  name: '',
  email: '',
  message: '',
}

const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || 'https://crewcoin.herokuapp.com/crewuser/contact';

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState)
  const [disable, setDisable] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const clearState = () => setState({ ...initialState })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (disable) return;

    setDisable(true)

    try {
      const response = await fetch(CONTACT_API_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: String(name || '').trim(),
          email: String(email || '').trim(),
          message: String(message || '').trim(),
          source: 'crewcoin-web-contact',
        }),
      })

      const payload = await response.json().catch(() => ({}))

      if (!response.ok || payload?.success === false) {
        throw new Error(payload?.message || 'Unable to send message right now.')
      }

      clearState()
      alert('Message sent!')
    } catch (error) {
      console.error(error)
      alert(error?.message || 'Unable to send message right now.')
    } finally {
      setDisable(false)
    }
  }

  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below and we will get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' validate onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        value={name}
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        value={email}
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    value={message}
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' disabled={disable} className='btn btn-custom btn-lg'>
                  {disable ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Location
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Phone
                </span>{' '}
                {props.data ? props.data.phone : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <h4>Find us in the App Store or the Google Play Store Today!</h4>
                <ul>
                  <li>
                    <a href="https://apps.apple.com/us/app/crew-coin/id1611964163" >
                      <i className='fa fa-apple'></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://play.google.com/store/apps/details?id=com.davwilliams.crewcoinapp">
                      <i className='fa fa-android'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>&copy; 2026 Crew Coin. All rights reserved.</p>
          <p className='cc-footer-links'>
            <a href='/#/faq'>FAQ</a> · <a href='/#/blog/restaurant-employee-incentive-ideas' target='_blank' rel='noreferrer'>Blog</a> · <a href='/#/restaurant-employee-incentive-app' target='_blank' rel='noreferrer'>Guide: Employee Incentives</a> · <a href='/#/reduce-restaurant-turnover' target='_blank' rel='noreferrer'>Guide: Reduce Turnover</a> · <a href='https://crewcoinprivacy.netlify.app/' target='_blank' rel='noreferrer'>Privacy Policy</a> · <a href='mailto:admin@crew-coin.com'>Support</a> · <a href='/#/account-deletion'>Account Deletion</a>
          </p>
        </div>
      </div>
    </div>
  )
}

